import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const ToolCard = ({ tool, index }) => {
  const Icon = tool.Icon;
  return (
    <Link className="tool-card reveal" style={{ animationDelay: `${index * 70}ms` }} to={tool.path} data-testid={`tool-card-${tool.id}`}>
      <div className="tool-card-top" data-testid={`tool-card-header-${tool.id}`}>
        <Icon size={22} aria-hidden="true" />
        <span data-testid={`tool-card-eyebrow-${tool.id}`}>{tool.eyebrow}</span>
      </div>
      <h3 data-testid={`tool-card-title-${tool.id}`}>{tool.title}</h3>
      <p data-testid={`tool-card-description-${tool.id}`}>{tool.description}</p>
      <span className="inline-action" data-testid={`tool-card-action-${tool.id}`}>{tool.action}<ArrowRight size={16} /></span>
    </Link>
  );
};